import { useState } from "react";
import type { ParticipationPromptPublic, ParticipationToday } from "@tih/shared";
import { useSiteCopy } from "../../context/SiteCopyContext";
import { getAtPath } from "../../lib/siteCopyPaths";
import { ParticipationPanel } from "./ParticipationPanel";
import { ParticipationPromptContent } from "./ParticipationPromptContent";

type Props = {
  prompts: ParticipationPromptPublic[];
  today: ParticipationToday | null;
  onUpdate: () => void;
  filterFamily?: "MINISTRY" | "EVENT_PREP";
};

export function ParticipationPromptGrid({ prompts, today, onUpdate, filterFamily }: Props) {
  const { copy } = useSiteCopy();
  const [active, setActive] = useState<ParticipationPromptPublic | null>(null);
  const filtered = filterFamily ? prompts.filter((p) => p.family === filterFamily) : prompts;

  return (
    <>
      <div className="participation-prompt-grid">
        {filtered.map((prompt) => {
          const featured = today?.spotlightSlug === prompt.slug;
          return (
            <button
              key={prompt.slug}
              type="button"
              className={`participation-prompt-card${featured ? " is-featured" : ""}`}
              onClick={() => setActive(prompt)}
            >
              {featured && (
                <span className="participation-prompt-badge">
                  {String(getAtPath(copy, "participate.featuredToday") ?? "Featured today")}
                </span>
              )}
              {prompt.dayLabel && (
                <span className="participation-prompt-eyebrow">{prompt.dayLabel}</span>
              )}
              <span className="participation-prompt-title">{prompt.title}</span>
              {prompt.subtitle && (
                <span className="participation-prompt-sub">{prompt.subtitle}</span>
              )}
            </button>
          );
        })}
      </div>

      {active && today && (
        <ParticipationPanel
          open={Boolean(active)}
          onClose={() => setActive(null)}
          title={active.title}
          subtitle={active.subtitle}
        >
          <ParticipationPromptContent
            prompt={active}
            stats={today.stats}
            registeredSeats={today.registeredSeats}
            prepChecklist={today.prepChecklist}
            eventId={today.featuredEvent?.id ?? null}
            onUpdate={onUpdate}
          />
        </ParticipationPanel>
      )}
    </>
  );
}
